import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Image from "../../shared/component/UI/Image";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import LogoHorizontal from "../../assets/logo/horizontal.svg";
import "./CreateAccount.scss";
import { CloseEyeIcon, /* GoogleIcon, */ OpenEyeIcon } from "../../shared/component/svg/Icons";
import Anchor from "../../shared/component/UI/Anchor";
import { generateRequestOptions, homeUrl } from "../../shared/utils/apiEndPoints";
import { toast } from "react-toastify";
import makeRequest from "../../shared/utils/request";

let USERNAME_REGEX = "^[\\w.@+-]+$"; // eslint-disable-line
let USERNAME_REGEX_PATTERN = new RegExp(/^[\w.@+-]+$/);

const CreateAccount = ({ ENV_NAME, isAuthenticated, setLoginModalShow, ...props }) => {
	const [errorMessage, setErrorMessage] = useState(null);
	const [form, setForm] = useState({});
	const [isShowPassword, setIsShowPassword] = useState(false);
	const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	useEffect(() => {
		if (isAuthenticated) props.history.push(RoutePath.ROOT);
	}, [isAuthenticated]); // eslint-disable-line

	const onChangeField = (e) => {
		errorMessage && setErrorMessage(false);
		if (e.target.name === "isCheckPrivacy") {
			setForm((p) => ({ ...p, [e.target.name]: e.target.checked }));
			return;
		}
		setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
	};

	const isAllFilled = () => {
		return (
			true && // So that it'll return a boolean
			form?.firstName &&
			form?.lastName &&
			form?.email &&
			form?.newUsername &&
			USERNAME_REGEX_PATTERN.test(form?.newUsername) &&
			form?.newPassword &&
			form?.confirmPass &&
			form?.isCheckPrivacy
		);
	};

	const createAccount = async () => {
		if (!isAllFilled()) return;
		if (form?.newPassword !== form?.confirmPass) {
			return setErrorMessage(Variable.PASSWORD_NOT_MATCHED[ENV_NAME]);
		}
		setIsProcessing(true);

		let res = await makeRequest({
			...generateRequestOptions("signUp"),
			data: {
				first_name: form?.firstName,
				last_name: form?.lastName,
				email: form?.email,
				username: form?.newUsername,
				password: form?.newPassword,
				is_active: true,
			},
			json: true,
		});

		if (res?.code === 200) {
			toast.success(Variable.REGISTER_SUCCESS[ENV_NAME]);
			props.history.push(RoutePath.ROOT);
		} else {
			toast.success(Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME]);
			setErrorMessage(readErrorMsg(res));
		}

		setIsProcessing(false);
	};

	const readErrorMsg = (res) => {
		if (!res?.detail?.errors) return res?.message || Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME];
		return res?.detail?.errors?.map((i, idx) => <div key={`errormsg-${idx}`}>{`${i?.field}: ${i?.message}`}</div>);
	};

	return (
		<div className="create-account">
			<div className="flex-all-center w-100 mb-lg">
				<Link to={RoutePath.ROOT}>
					<Image src={LogoHorizontal} alt="logo" />
				</Link>
			</div>
			<div className="ca-form-cont">
				<h4 className="mb-lg text-center">
					<strong>{Variable.LETS_CREATE_ACCOUNT[ENV_NAME]}</strong>
				</h4>
				{/* <button className="btn btn-cta-secondary btn-sm btn-google-signin w-100 p-sm">
					<GoogleIcon width="2.4rem" height="2.4rem" className="me-med" />
					<span className="text-label-dark-gray-2 font-weight-medium">
						{Variable.SIGNUP_WITH_GOOGLE[ENV_NAME]}
					</span>
				</button>
				<div className="divider my-xl-custom" /> */}
				<form
					onSubmit={(e) => {
						e.preventDefault();
						createAccount();
					}}
					autoComplete="new-password"
				>
					{/* <h4 className="mb-lg text-center">
						<strong>{Variable.OR_FILL_FORM_BELOW[ENV_NAME]}</strong>
					</h4> */}
					<div className="form-group">
						<label htmlFor="login" className="font-weight-medium">
							{Variable.FIRST_NAME[ENV_NAME]}
						</label>
						<input
							id="firstName"
							type="text"
							className={`form-control ${errorMessage ? "border-danger" : ""}`}
							name="firstName"
							value={form?.firstName || ""}
							onChange={onChangeField}
							placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.FIRST_NAME[ENV_NAME]}`}
							required
							disabled={isProcessing}
						/>
					</div>
					<div className="form-group mb-0">
						<label htmlFor="login" className="font-weight-medium">
							{Variable.LAST_NAME[ENV_NAME]}
						</label>
						<input
							id="lastName"
							type="text"
							className={`form-control ${errorMessage ? "border-danger" : ""}`}
							name="lastName"
							value={form?.lastName || ""}
							onChange={onChangeField}
							placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.LAST_NAME[ENV_NAME]}`}
							required
							disabled={isProcessing}
						/>
					</div>
					<div className="divider my-lg" />
					<div className="form-group">
						<label htmlFor="login" className="font-weight-medium">
							{Variable.EMAIL[ENV_NAME]}
						</label>
						<input
							id="email"
							type="email"
							className={`form-control ${errorMessage ? "border-danger" : ""}`}
							name="email"
							value={form?.email || ""}
							onChange={onChangeField}
							placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.EMAIL[ENV_NAME]}`}
							required
							disabled={isProcessing}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="login" className="font-weight-medium">
							{Variable.USERNAME[ENV_NAME]}
						</label>
						<input
							id="newUsername"
							type="text"
							className={`form-control ${
								errorMessage || (form?.newUsername && !USERNAME_REGEX_PATTERN.test(form?.newUsername))
									? "border-danger"
									: ""
							}`}
							name="newUsername"
							value={form?.newUsername || ""}
							onChange={onChangeField}
							placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.USERNAME[ENV_NAME]}`}
							required
							disabled={isProcessing}
							pattern={USERNAME_REGEX}
							maxLength={150}
						/>
						{form?.newUsername && !USERNAME_REGEX_PATTERN.test(form?.newUsername) && (
							<span className="error-txt">{Variable.USERNAME_ACCEPT[ENV_NAME]}</span>
						)}
					</div>
					<div className="form-group">
						<label htmlFor="password" className="font-weight-medium">
							{Variable.PASSWORD[ENV_NAME]}
						</label>
						<div className="position-relative">
							<input
								id="newPassword"
								type={isShowPassword ? "text" : "password"}
								className={`form-control ${errorMessage ? "border-danger" : ""}`}
								name="newPassword"
								value={form?.newPassword || ""}
								onChange={onChangeField}
								placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.PASSWORD[ENV_NAME]}`}
								autoComplete="new-password"
								required
								disabled={isProcessing}
							/>
							<div
								className={`pwd-eye cursorPointer ${!isShowPassword ? "active" : ""}`}
								onClick={() => setIsShowPassword((p) => !p)}
							>
								{isShowPassword ? (
									<OpenEyeIcon width="1.6rem" height="1.6rem" stroke="#193560" />
								) : (
									<CloseEyeIcon width="1.6rem" height="1.6rem" stroke="#BEC4CF" />
								)}
							</div>
						</div>
					</div>
					<div className="form-group">
						<label htmlFor="password" className="font-weight-medium">
							{Variable.CONFIRM_PASSWORD[ENV_NAME]}
						</label>
						<div className="position-relative">
							<input
								id="confirmPass"
								type={isShowConfirmPassword ? "text" : "password"}
								className={`form-control ${errorMessage ? "border-danger" : ""}`}
								name="confirmPass"
								value={form?.confirmPass || ""}
								onChange={onChangeField}
								placeholder={`${Variable.ENTER[ENV_NAME]} ${Variable.CONFIRM_PASSWORD[ENV_NAME]}`}
								autoComplete="new-password"
								required
								disabled={isProcessing}
							/>
							<div
								className={`pwd-eye cursorPointer ${!isShowConfirmPassword ? "active" : ""}`}
								onClick={() => setIsShowConfirmPassword((p) => !p)}
							>
								{isShowConfirmPassword ? (
									<OpenEyeIcon width="1.6rem" height="1.6rem" stroke="#193560" />
								) : (
									<CloseEyeIcon width="1.6rem" height="1.6rem" stroke="#BEC4CF" />
								)}
							</div>
						</div>
					</div>
					<div className="form-group form-check mb-0">
						<div className="custom-control custom-checkbox">
							<input
								type="checkbox"
								className="form-check-input"
								id="isCheckPrivacy"
								name="isCheckPrivacy"
								checked={form?.isCheckPrivacy || false}
								onChange={onChangeField}
								disabled={isProcessing}
							/>
							<label className="form-check-label" htmlFor="isCheckPrivacy">
								{`${Variable.ACCEPT_PRIVACY_POLICY[ENV_NAME]} `}
								<Anchor
									href={"https://" + homeUrl + RoutePath.PRIVACY_POLICY}
									className="text-decoration-none"
								>
									Portal Sekolah
								</Anchor>
								{` ${Variable.PARENT_UNDERAGE_CONSENT[ENV_NAME]}`}
							</label>
						</div>
					</div>
					{errorMessage && <div className="error-msg mt-1p6rem mb-0">{errorMessage}</div>}
					<button
						type="submit"
						className="btn btn-cta-primary btn-block w-100"
						disabled={!isAllFilled() || isProcessing}
					>
						{isProcessing ? (
							<div className="spinner-border" role="status">
								<span className="visually-hidden">{Variable.LOADING_LABEL[ENV_NAME]}</span>
							</div>
						) : (
							Variable.REGISTER[ENV_NAME]
						)}
					</button>
				</form>
				<div className="divider my-xl-custom" />
				<div className="flex-all-center flex-column">
					<h4>
						<strong>{Variable.ALREADY_HAVE_ACCOUNT[ENV_NAME]}</strong>
					</h4>
					<h4 className="text-label-blue-gradient cursorPointer" onClick={() => setLoginModalShow(true)}>
						<strong>{Variable.CLICK_HERE_LOGIN[ENV_NAME]}</strong>
					</h4>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return { isAuthenticated: state.auth.isAuthenticated, ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};

const mapStateToDispatch = (dispatch) => {
	return {
		setLoginModalShow: (payload = true) => {
			if (payload) {
				dispatch({
					type: ActionTypes.OPEN_LOGIN_MODAL,
				});
			} else {
				dispatch({
					type: ActionTypes.CLOSE_LOGIN_MODAL,
				});
			}
		},
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(CreateAccount));
